$(".filter-select__show").click(function () {
    $(this).parents(".filter-select").toggleClass("_active")
    if(window.innerWidth<=576){
        $("body").addClass("fixed-body")
    }
})

$(document).mouseup(function(e) {
    var div = $('.filter-select__dropdown');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).parents(".filter-select").hasClass("_active")){
            $(div).parents(".filter-select").removeClass("_active")
            $("body").removeClass("fixed-body")
        }
    }
});

$(".filter-select__apply").click(function () {
    let parent = $(this).parents(".filter-select")
    let checks = 0
    let doctors = $(parent).find(".filter-select__doctor").length
    if(doctors > 0){
        checks = $(parent).find(".filter-select__doctor input[type='checkbox']:checked").length
    } else{
        checks = $(parent).find(".filter-select__check input[type='checkbox']:checked").length
    }
    $(parent).removeClass("_active")
    $("body").removeClass("fixed-body")


    if(checks>0){
        $(parent).find(".filter-select__current").attr("data-count",checks)
        $(parent).addClass("_filtered")
    } else{
        $(parent).find(".filter-select__current").attr("data-count","")
        $(parent).removeClass("_filtered")
    }


})

$(".filter-select__refresh").click(function () {
    let parent = $(this).parents(".filter-select")
    $(this).parents(".filter-select").removeClass("_active")
    $("body").removeClass("fixed-body")
    $(parent).find(".filter-select__check input").each(function (index, el){
        $(el).prop("checked",false)
    });
    $(parent).find(".filter-select__current").attr("data-count","")
    $(parent).removeClass("_filtered")
})



$(".filter-select__check input[type='radio']").change(function () {
    let parent = $(this).parents(".filter-select")
    let label = $(this).siblings("label").text().trim()
    $(".filter-select").removeClass("_active")
    $("body").removeClass("fixed-body")
    $(parent).find(".filter-select__current").text(label)
    $(parent).addClass("_filtered")
})

$(".filter-select__doctor input").change(function () {
    let checked = $(this).prop("checked")
    let checkedInputs = $(".filter-select__doctor input:checked").length
    if(checked){
        $(".filter-select__doctor").addClass("_disabled")
    }
    if(checkedInputs < 1){
        $(".filter-select__doctor").removeClass("_disabled")
    }
})


